import React, { useEffect, useState } from "react";
import {
  Stack,
  Tooltip,
  ClickAwayListener,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { Link } from "react-router-dom";
import {
  handleSpringDataRequest,
  handleSpringDataMutationRequest,
} from "../../../api";
import { toast } from "material-react-toastify";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { checkValidName } from "../../../Utils/Utils";
import { ShopImgLoaders } from "../Shop/Utils/CardLoaders";
import * as RiIcons from "react-icons/ri";
import { useTranslation } from "react-i18next";

const styles = {
  position: "absolute",
  top: 28,
  right: 0,
  left: -150,
  zIndex: 100,
  p: "8px",
  bgcolor: "background.paper",
  minWidth: "250px",
  boxShadow: 24,
  borderRadius: "10px",
};

// Wrapper component
export const WrapperComponent = ({
  component,
  modifyShopName,
  shopName,
  data,
  id,
  fnb,
  hotelId,
  selfService,
  description,
}) => {
  return (
    <Tooltip title={`Take me to ${modifyShopName(shopName)}`} placement="top">
      <Link
        to={{
          pathname: `/outlet/${id}/${modifyShopName(shopName)}/${
            fnb ? "fnb" : "other"
          }/dashboard`,
          // JSON.parse(data?.accessControl?.user_feature_map?.POSDashboard)
          //   .read === "YES" &&
          search: `?hotelId=${hotelId}`,
        }}
        style={{ textDecoration: "none", color: "black" }}
      >
        {component}
      </Link>
    </Tooltip>
  );
};

function AllShopCards({
  imageUrl = null,
  shopName,
  description,
  selfService,
  id,
  hotelId,
  fnb,
  data,
}) {
  const { t } = useTranslation();

  //States
  const [hotelImageList, sethotelImageList] = useState(null);

  //get images for a selected shop
  useEffect(() => {
    handleSpringDataRequest(`core/api/v1/image/get-shop-images?shopId=${id}`)
      .then((res) => sethotelImageList(res.imageList))
      .catch((err) =>
        toast.error(
          `${t("Error in fetching the shops images! Please try again later.")}`
        )
      );
  }, []);

  // Modify shop name if contains special characters
  function modifyShopName(name) {
    if (checkValidName(name) === false) {
      let updatedShopName = name.replace("/", " ");
      return String(updatedShopName);
    } else {
      return String(name);
    }
  }

  // Open the click away listener on clicking on the button
  const [openStaffDetails, setOpenStaffDetails] = useState(false);
  const handleOpenStaffDetails = () => {
    setOpenStaffDetails((prev) => !prev);
  };
  const handleClickAwayStaffDetails = () => {
    setOpenStaffDetails(false);
  };

  // Currently selected staff
  const [currentSelectedStaff, setCurrentSelectedStaff] = useState(null);

  // All staff details
  const [allStaffDetails, setAllStaffDetails] = useState(null);
  // Get the details of the current selected staff
  const handleGetAccessListStaff = async () => {
    try {
      const res = await handleSpringDataRequest(
        `core/api/v1/shop/category/get-shop-access-users?shopId=${id}`
      );
      setAllStaffDetails(res);
    } catch (err) {
      toast.error(err);
    }
  };

  useEffect(() => {
    handleGetAccessListStaff();
    // Clearing out the selected staff once you leave
    return () => {
      setCurrentSelectedStaff(null);
      setAllStaffDetails(null);
    };
  }, [id]);

  useEffect(() => {
    if (allStaffDetails) {
      const res = Object.keys(allStaffDetails).filter((key) => {
        if (allStaffDetails[key]) return key;
      });
      setCurrentSelectedStaff(res);
    }
  }, [allStaffDetails]);

  const handleChangeStaffStatus = (email) => {
    if (currentSelectedStaff.includes(email)) {
      const emailIdx = currentSelectedStaff?.indexOf(email);
      currentSelectedStaff.splice(emailIdx, 1);
      return setCurrentSelectedStaff([...currentSelectedStaff]);
    }
    return setCurrentSelectedStaff([...currentSelectedStaff, email]);
  };

  // Allow admin to give the access to the users
  const [updateLoader, setUpdateLoader] = useState(false);
  const handleUpdateAccess = async () => {
    setUpdateLoader(true);
    try {
      const res = await handleSpringDataMutationRequest(
        "PUT",
        `core/api/v1/shop/category/add-update-shop-access`,
        { userEmails: currentSelectedStaff?.join(","), shopId: id }
      );
      toast.success(res);
      handleGetAccessListStaff();
    } catch (err) {
      toast.error(err);
    } finally {
      setUpdateLoader(false);
      handleClickAwayStaffDetails();
    }
  };
  // core/api/v1/shop/category/add-update-shop-access?hotelId=20167

  return (
    // <Tooltip title={`Take me to ${modifyShopName(shopName)}`} placement="top">
    //   <Link
    //     to={{
    //       pathname:
    //         JSON.parse(data?.accessControl?.user_feature_map?.POSDashboard)
    //           .read === "YES" &&
    //         `/outlet/${id}/${modifyShopName(shopName)}/${
    //           fnb ? "fnb" : "other"
    //         }/dashboard`,
    //       search: `?hotelId=${hotelId}`,
    //     }}
    //     style={{ textDecoration: "none", color: "black" }}
    //   >
    <div
      className="allShopCardWrapper w-100 d-flex hover-shadow flex-start border border-top border-end border-bottom border-3 border-light rounded bg bg-white"
      style={{
        position: "relative",
        height: "200px",
        cursor: "pointer",
        // cursor:
        //   JSON.parse(data?.accessControl?.user_feature_map?.POSDashboard)
        //     .read === "YES"
        //     ? "pointer"
        //     : "not-allowed",
      }}
    >
      <Stack
        direction="row"
        spacing={5}
        style={{ position: "relative", width: "100%" }}
      >
        <WrapperComponent
          modifyShopName={modifyShopName}
          shopName={shopName}
          data={data}
          id={id}
          fnb={fnb}
          hotelId={hotelId}
          component={
            hotelImageList ? (
              <Stack
                className="ml-2"
                style={{
                  position: "relative",
                  width: "100%",
                  height: "175px",
                  width: "300px",
                  display: "flex",
                  alignSelf: "center",
                  marginTop: "10px",
                }}
              >
                <img
                  src={
                    hotelImageList.length > 0
                      ? hotelImageList[0].imageUrl
                      : toAbsoluteUrl("media/shops/defaultImg.png")
                  }
                  alt=""
                  height="100%"
                  width="100%"
                  className="border rounded"
                />
              </Stack>
            ) : (
              <ShopImgLoaders />
            )
          }
        />

        <Stack style={{ position: "relative", width: "90%" }}>
          <WrapperComponent
            selfService={selfService}
            description={description}
            shopName={shopName}
            data={data}
            id={id}
            fnb={fnb}
            hotelId={hotelId}
            modifyShopName={modifyShopName}
            component={
              <Stack spacing={5}>
                <Stack
                  style={{
                    marginTop: "25px",
                    position: "relative",
                    width: "85%",
                  }}
                >
                  <h4>{shopName}</h4>
                  <div style={{ color: "#A68787", fontSize: "12.5px" }}>
                    {selfService.toLowerCase() === "yes"
                      ? `${t("Self Service Enabled")}`
                      : `${t("Self Service Disabled")}`}
                  </div>
                </Stack>
                <div
                  style={{
                    fontSize: "12.5px",
                    flexWrap: "wrap",
                    marginRight: "15px",
                  }}
                >
                  {description}
                </div>
              </Stack>
            }
          />
        </Stack>

        {data.accessControl?.ADMINRIGHTS === "ADMIN" &&
          allStaffDetails &&
          currentSelectedStaff && (
            <Tooltip title="Staff access control">
              <div
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  fontSize: "14px",
                }}
              >
                <ClickAwayListener onClickAway={handleClickAwayStaffDetails}>
                  <Box sx={{ position: "relative" }}>
                    <Typography onClick={handleOpenStaffDetails}>
                      <RiIcons.RiUserSettingsLine size="15px" color="grey" />
                    </Typography>
                    {openStaffDetails ? (
                      Object.keys(allStaffDetails).length > 0 ? (
                        <Box sx={styles}>
                          <Stack spacing={1}>
                            {Object.entries(allStaffDetails)?.map(
                              ([key, value]) => (
                                <Typography
                                  style={{
                                    backgroundColor:
                                      currentSelectedStaff?.includes(key)
                                        ? "#e4e4e4"
                                        : "transparent",
                                    padding: "5px",
                                    borderRadius: "15px",
                                    fontSize: "10px",
                                  }}
                                  onClick={() => handleChangeStaffStatus(key)}
                                >
                                  {key}
                                </Typography>
                              )
                            )}
                          </Stack>
                          <Stack
                            style={{
                              position: "relative",
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: "10px",
                            }}
                            direction={"row"}
                            onClick={() =>
                              !updateLoader && handleUpdateAccess()
                            }
                          >
                            <Typography> </Typography>
                            <Typography
                              style={{
                                fontWeight: 500,
                                backgroundColor: "black",
                                borderRadius: "5px",
                                padding: "2.5px",
                                width: "50px",
                                color: "white",
                                fontSize: "12px",
                                textAlign: "center",
                              }}
                            >
                              {updateLoader ? (
                                <CircularProgress size="10px" />
                              ) : (
                                `${t("Apply")}`
                              )}
                            </Typography>
                          </Stack>
                        </Box>
                      ) : (
                        <Box sx={styles}>
                          <Stack
                            sx={{
                              padding: "10px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {t("No users present")}
                          </Stack>
                        </Box>
                      )
                    ) : null}
                  </Box>
                </ClickAwayListener>
              </div>
            </Tooltip>
          )}
      </Stack>
    </div>
    //   </Link>
    // </Tooltip>
  );
}

export default AllShopCards;
